<template lang="">
  <tabela-cadastro
    :headers="headers"
    :items="tarifas"
    @save="save"
    @prepareEdit="prepareEdit"
    @delete="deleteItem"
    @reset="form = {...formDefault}"
    custom_class="table my-10"
    name="Hora"
    ref="tabela"
  >
      
    <template v-slot:form-cadastro="{ title, close }">
      <v-card>
        <v-card-title class="v-card mb-4">
          <span class="headline">{{ title }}</span>
        </v-card-title>
        <v-card-text class="pa-5 border-bottom">
          <validation-observer ref="observer">
            <form ref="form" class="container">
              <v-row>
                <v-col class="py-0" cols="12" sm="12" md="12">
                  <validation-provider
                    v-slot="{ errors }"
                    name="valor"
                    rules="required"
                  >
                    <vuetify-money
                      ref="valor"
                      v-model="form.valor"
                      :error-messages="errors"
                      label="Valor fixo"
                      v-bind:options="options"
                    />
                  </validation-provider>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="py-0" cols="12" sm="12" md="12">
                  <validation-provider
                    v-slot="{ errors }"
                    name="tolerancia"
                    rules="required"
                  >
                    <v-text-field
                      type="number"
                      ref="tolerancia"
                      v-model="form.tolerancia"
                      :error-messages="errors"
                      label="Tolerância"
                      required
                    />
                  </validation-provider>
                </v-col>
              </v-row>
              <v-card class="mt-6 pb-2 px-3" v-for="(cobranca, index) of form.excedente" :key="index">
                <v-row>
                  <v-col class="py-0 d-flex" cols="12" sm="12" md="12">
                    <validation-provider
                      v-slot="{ errors }"
                      name="valor adicional"
                      rules="required"
                      style="width: 80%"
                    >
                      <vuetify-money
                        ref="valor"
                        v-model="form.excedente[index].valor"
                        :error-messages="errors"
                        label="Valor da hora adicional"
                        v-bind:options="options"
                        required
                      />
                    </validation-provider>
                    <v-icon style="width: 20%" @click="form.excedente.splice(index, 1)">mdi-delete</v-icon>
                  </v-col>

                </v-row>
                <v-row>
                  <v-col class="py-0" cols="12" sm="12" md="12">
                    <validation-provider
                      v-slot="{ errors }"
                      name="excedente"
                      rules="required"
                    >
                      <v-text-field
                        type="number"
                        ref="excedente"
                        v-model="form.excedente[index].doravante"
                        :error-messages="errors"
                        label="Cobrança/Excedente a partir de"
                        required
                      />
                    </validation-provider>
                  </v-col>

                </v-row>
              </v-card>
              <v-row class="justify-center mt-3">
                <v-btn
                  elevation="2"
                  color="info"
                  @click="adicionarExcedente"
                >
                  Adicionar cobrança/excedente
                </v-btn>
              </v-row>
            </form>
          </validation-observer>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <buttons-cadastro @close="close" @save="save" />
        </v-card-actions>
      </v-card>
    </template>
  </tabela-cadastro>
</template>
<script>

import { mapState, mapActions } from 'vuex'
import TabelaCadastro from '@/components/TabelaCadastro/TabelaCadastro.vue';
import ButtonsCadastro from '@/components/ButtonsCadastro/ButtonsCadastro.vue';

export default {
  name: 'Hora',
  props: {
    servico: {
      type: Object,
      required: true
    },
    servico_autorizado: {
      type: Boolean,
      default: false,
    },
  },
  components: { TabelaCadastro, ButtonsCadastro },
  data() {
    return {

      headers: [
        { text: 'Valor', value: 'valor' },
        { text: 'Tolerância', value: 'tolerancia' },
        { text: 'Ações', value: 'actions', sortable: false },
      ],
      form: {
        id: null,
        valor: null,
        tolerancia: null,
        excedente: [
          {
            valor: null,
            doravante: null
          }
        ]
      },
      formDefault: {
        id: null,
        valor: null,
        tolerancia: null,
        excedente: [
          {
            valor: null,
            doravante: null
          }
        ]
      },
      excedenteDefault: [
        {
          valor: null,
          doravante: null
        }
      ],
      options: {
        locale: "pt-BR",
        prefix: "R$",
        suffix: "",
        length: 11,
        precision: 2
      }
    }
  },

  computed: {
    ...mapState('patio', ['tarifas']),
    ...mapState('auth', ['empresaAtual']),
  },

  mounted() {
    if (!this.empresaAtual.public_id) return
    this.getTarifas();
  },

  methods: {
    ...mapActions('patio', ['getServicoTarifa', 'getServicoAutorizadoTarifa']),

    async getTarifas() {
      const get = this.servico_autorizado
        ? this.getServicoAutorizadoTarifa
        : this.getServicoTarifa
      await get({
        tipoTarifa: this.servico.tipoTarifa,
        proprietario: this.empresaAtual.public_id,
        ...(this.servico_autorizado
          ? { servico_autorizado: this.servico.public_id_autorizado }
          : { servico: this.servico.id }),
      })
    },

    validate() {
      this.$refs.observer.validate()
      const isValid = !this.$refs.observer.flags.invalid
      return isValid
    },

    reset() {
      if (this.$refs.observer && this.$refs.observer.reset) {
        this.$refs.observer.reset()
      }
      this.$refs['tabela'].close()
      this.$nextTick(() => {
        Object.assign(this.form, this.formDefault)
        this.form.excedente = [
          {
            valor: null,
            doravante: null
          }
        ];
      })
    },

    async save() {
      if (!this.validate()) return

      if (this.$refs['tabela'].$data.isEdit) {
        await this.$emit('edit', { ...this.form, valor: this.form.valor, tipoTarifa: 'hora' })
      } else {
        await this.$emit('save', { ...this.form, valor: this.form.valor, tipoTarifa: 'hora' })
      }
    },

    prepareEdit(hora) {
      this.form = {...hora}
      return
    },

    deleteItem(tarifa) {
      this.$emit('deleteItem', { ...tarifa, tipoTarifa: 'hora' })
    },

    adicionarExcedente() {
      this.form.excedente.push({
        valor: null,
        doravante: null
      })
    }
  }
}
</script>
<style>
.table {
  width: 50%;
  margin: auto;
}
</style>